import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@websky/core/src';
import * as theme from './SearchFormDatepickerButtons.css';
import { useCallback } from 'react';
import cn from 'classnames';
export const SearchFormDatepickerMobileButtons = props => {
    const { t } = useTranslation('SearchFormDatepicker');
    const { onDone, isDoneable, onClear, isDateBackSelected, isDateToSelected, isMultyCity, onClose } = props;
    const handleClear = useCallback(() => {
        if (!isDateToSelected && !isDateToSelected) {
            onClose();
        }
        onClear();
    }, [isDateToSelected, isDateBackSelected]);
    const renderDoneButtonContent = useCallback(() => {
        if (isDateToSelected) {
            if (isDateBackSelected || isMultyCity) {
                return t('Done');
            }
            else {
                return t('Without back date');
            }
        }
        else {
            return t('Done');
        }
    }, [isDateBackSelected, isDateToSelected, isMultyCity]);
    if (!isDoneable) {
        return null;
    }
    return (React.createElement("div", { className: theme.buttons },
        React.createElement(Button, { onClick: handleClear, className: cn(theme.button, theme.clear) }, t('Clear')),
        React.createElement(Button, { onClick: isDoneable ? onDone : null, className: theme.button }, renderDoneButtonContent())));
};
export default SearchFormDatepickerMobileButtons;
